// 删除账号 再次提示界面 1

require("clover/panel/component/common/UIGroupButton")

let AccountDelTipAgainPanel = xClass("AccountDelTipAgainPanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.Node.create()
})
let RES = table(
    "packed/logout.pack"
)
AccountDelTipAgainPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}
AccountDelTipAgainPanel.preloadResPromise = function(useMask = false) {
    return preloadWithLoadingPromise(RES, useMask)
}
let _instance = null
AccountDelTipAgainPanel.getInstance = function () {
    let self = this
    return _instance
}
AccountDelTipAgainPanel.prototype.ctor = function (data) {
    let self = this
    // super 
    // BasePanel.ctor(self)
    BasePanel.prototype.ctor.call(self);
    _instance = self
    self.aManager = AccountManager.getInstance()
    self.aManager.dcDelTipAgainPanelOpen()
    self.initUI();
}
AccountDelTipAgainPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    // BasePanel.onClose(self, callback)
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);

}
AccountDelTipAgainPanel.prototype.onCleanup = function () {
    let self = this
    // ref 
    _instance = null
    beforeClose(self);
    ResManager.release(RES);
    // FrameLoader.unloadImageWithPlists(RES, true)
    // cc.Director.getInstance().getTextureCache().removeUnusedTextures()
}
/**
 * 关闭前的操作
 * 关闭一些动画、定时操作
 * @param {*} self 
 */
function beforeClose(self) {}


AccountDelTipAgainPanel.prototype.initUI = function () {
    let self = this
    self.mainNode = cc.CSLoader.createNode("cocos/logout_logout_confirmation.csb")
    self.addChild(self.mainNode);

    this.btnClose = self.mainNode.getChildByName("close");
    quickBuildBtn(this.btnClose, UIGroupButton, PushBounceAnim, () => {
        self.aManager.dcDelTipAgainPanelClick("out")
        this.onClose();
    }, true);

    self.mainNode.getChildByName("txt2").setVisible(false)
    // let contentStr = getText("delete.page3.text") //船长还在期待着和你一起出海远航，真的要离开船长吗？

    // self.mainNode.getChildByName("txt2").setString(contentStr)
    // self.mainNode.getChildByName("txt2").getVirtualRenderer().setLineHeight(30)

    let contentStr = getText("delete.page3.text")
    let contentLable = cc.Label.createWithSystemFont(contentStr, "Arial", 20)
    contentLable.setDimensions(200, 0)
    contentLable.setColor(cc.color(155, 91, 63))
    contentLable.y = 100
    contentLable.x = 155
    contentLable.setLineHeight(30)
    self.mainNode.addChild(contentLable)
    // self.mainNode.getChildByName("txt2").height = 500

    this.btnConfirm = self.mainNode.getChildByName("logout_delete");
    quickBuildBtn(this.btnConfirm, UIGroupButton, PushBounceAnim, () => {
        if (this.isbusy) return
        this.isbusy = true
        self.aManager.dcDelTipAgainPanelClick("delete")
        self.aManager.showDelRealPanel()
        this.onClose();
        this.isbusy = false
    }, true);

    this.btnBack = self.mainNode.getChildByName("button");
    quickBuildBtn(this.btnBack, UIGroupButton, PushBounceAnim, () => {
        // self.aManager.showProposePanel()
        self.aManager.dcDelTipAgainPanelClick("cancel")
        this.onClose();
    }, true);
    this.btnBack.getChildByName("txt").setString("返回游戏")


}
module.exports = AccountDelTipAgainPanel